<div class="ui-numeric-input-stepper">
  <div class="flex items-center gap-3">
    @if (showButtons()) {
      <ui-button
        class="flex-shrink-0"
        [icon]="'griddy-minus'"
        [size]="buttonSize()"
        variant="tertiary"
        [disabled]="!canDecrement()"
        (onClick)="decrement()" />
    }

    <input
      class="flex-1"
      type="number"
      [value]="value() ?? ''"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      [readonly]="readonly()"
      [min]="min()"
      [max]="max()"
      [step]="allowDecimals() ? step() : 1"
      [ngClass]="inputClasses()"
      (input)="onInputChange($event)"
      (blur)="onInputBlur()"
      (focus)="onInputFocus()" />

    @if (showButtons()) {
      <ui-button
        class="flex-shrink-0"
        [icon]="'griddy-plus'"
        [size]="buttonSize()"
        variant="tertiary"
        [disabled]="!canIncrement()"
        (onClick)="increment()" />
    }
  </div>
</div>
